import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const MaintananceReadings = createAsyncThunk(
  "bill/MaintananceReading",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;

      if (id) {
        // 🔵 Tenant side (Update)
        response = await axios.post(
          `${BASE_URL}/update-maintanance-reading/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // 🟢 Owner side (Create)
        response = await axios.post(
          `${BASE_URL}/maintanance-reading`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



const MaintananceReading = createSlice({
    name: "MaintananceReading",
    initialState: {
        loading: false,
        MaintananceReading: [],
        error: ""
    },
    extraReducers: {
        [MaintananceReadings.fulfilled]: (state, action) => {
            state.MaintananceReading = action.payload;
            state.loading = false;
        },
        [MaintananceReadings.pending]: (state) => {
            state.loading = true;
        },
        [MaintananceReadings.rejected]: (state, action) => {
            state.error = action.error.message;
            state.loading = false;
        },
    }
});
export default MaintananceReading.reducer;
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { BASE_URL } from "../../config/config";


// export const MaintananceReadings = createAsyncThunk(
//   "dummyData/MaintananceReading",
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/maintanance-reading`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Accept: "application/json",
//             // Authorization: "Bearer " + token,
//           },
//         }
//       );
      
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );




// const MaintananceReading = createSlice({
//   name: "maintananceReading",
//   initialState: {
//     loading: false,
//     data: null,
//     error: null,
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(MaintananceReadings.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(MaintananceReadings.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload;
//       })
//       .addCase(MaintananceReadings.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default MaintananceReading.reducer;